import { CallQueueInCampaignOutSchema } from "@/api/client";
import { CampaignAgent } from "@/helpers/types/add-ons/salesCampaign";
import { defineStore } from "pinia";
import { useAddonStore } from "./index.store";

interface SalesCampaignAddOnState {
  showCreatecampaignModal: boolean;
  showAssignTeamModal: boolean;
  showDistributeContectModal: boolean;
  showAddSingleContactToCampaign: boolean;
  showEditCampaign: boolean;
  currentAgentViewingCampaign?: CampaignAgent | null;
  currentAgentViewingCallQueueDetails?: CallQueueInCampaignOutSchema | null;
  showTeamMemberLimitModal: boolean;
  showExtendTeamLimitModal: boolean;
}

export const useSalesCampaignAddOnStore = defineStore("sales-campaign-addon", {
  state: (): SalesCampaignAddOnState => ({
    showCreatecampaignModal: false,
    showAssignTeamModal: false,
    showDistributeContectModal: false,
    showAddSingleContactToCampaign: false,
    showEditCampaign: false,
    currentAgentViewingCampaign: null,
    currentAgentViewingCallQueueDetails: null,
    showTeamMemberLimitModal: false,
    showExtendTeamLimitModal: false,
  }),
  getters: {
    getAgentHasAccess() {
      const addonStore = useAddonStore();

      const hasAccessToCampaign = addonStore.getAllEnhancedAddons.some(
        (addon) => addon.title?.includes("Campaign Addon") && addon.isPurchased
      );

      return hasAccessToCampaign;
    },
  },
});
